 <template>
    <div class="search">
      <van-popup style="height: 100vh;overflow-x: hidden" v-model="isShow" position="bottom" >
        <van-nav-bar @click-left="onClickLeft" @click-right="onClickLeft" :border="false">
          <span slot="left" style="font-size: 17px">
             <van-icon color="black" name="arrow-left"></van-icon>
          </span>
  <!--        <span slot="right" style="font-size: 17px">-->
  <!--       <van-icon color="black" name="../../assets/img/icon/searchBlack.png"></van-icon>-->
  <!--    </span>-->
          <span slot="title" style="font-size: 17px;color: #505050;">{{row.title}}</span>
        </van-nav-bar>
  <!--        <div class="centerBox" style="width: 100vw;height: 9.6vw;border-top: .13vw solid #757575">-->
  <!--            <div class="centerBox" style="font-size: 3.47vw;color: #757575">-->
  <!--                销量-->
  <!--            </div>-->
  <!--            <div class="centerBox" style="font-size: 3.47vw;color: #757575">-->
  <!--                价格-->
  <!--                <img src="../../assets/img/icon/sortAll.png" style="width: 1.6vw">-->
  <!--            </div>-->
  <!--        </div>-->
        <div style="width: 94%;margin: 0 auto;height: calc(100vh - 54px); padding: 0 3vw;background: #f6f7f8">
          <van-list
            v-model="pagingData.loading"
            :finished="pagingData.finished"
            style="height: calc(100vh - 100px - 13.07vw);overflow-y: auto"
            finished-text="我们是有底线的~"
            :immediate-check="false"
            @load="onLoad"
          >
              <div style="width: 100%;margin-top: 4.1vw;display: flex;flex-wrap: wrap;justify-content: space-between">
<!--                  <div style="width: 100%">-->
                    <div v-for="(item) in shopList" :key="item.id">
                      <my-shop-card style="width: 45.7vw;" :row="item" @plusTwo="changeCartGoodsNumTwo(arguments)" @minusTwo="minusCartGoodsNumTwo(arguments)" @toInfo="toInfo" @expend="changeExpend" @changeShop="changeShop(item)"></my-shop-card>
                    </div>
                    <div v-for="(item) in shopList2" :key="item.id">
                      <search-plist style="width: 45.7vw;" :row="item" @plusTwo="addPinSecorend(arguments)" @minusTwo="jjPinSecorend(arguments)" @expend="changeExpend"></search-plist>
                    </div>
<!--                  </div>-->
<!--                  <div style="width: 45.7vw;">-->
<!--                      <div v-for="(item, index) in shopList" :key="item.id">-->
<!--                          <my-shop-card style="width: 45.7vw;" v-if="index % 2 == 0" :row="item" @plusTwo="changeCartGoodsNumTwo(arguments)" @minusTwo="minusCartGoodsNumTwo(arguments)" @toInfo="toInfo" @expend="changeExpend" @changeShop="changeShop(item)"></my-shop-card>-->
<!--                      </div>-->
<!--                      <div v-for="(item, index) in shopList2" :key="item.id">-->
<!--                          <search-plist style="width: 45.7vw;" v-if="index % 2 == 0" :row="item" @plusTwo="addPinSecorend(arguments)" @minusTwo="jjPinSecorend(arguments)" @toInfo="toInfo" @expend="changeExpend"></search-plist>-->
<!--                      </div>-->
<!--                  </div>-->
<!--                  <div style="width: 45.7vw;">-->
<!--                      <div v-for="(item, index) in shopList" :key="item.id">-->
<!--                          <my-shop-card style="width: 45.7vw;" v-if="index % 2 != 0" :row="item" @plusTwo="changeCartGoodsNumTwo(arguments)" @minusTwo="minusCartGoodsNumTwo(arguments)" @toInfo="toInfo" @expend="changeExpend" @changeShop="changeShop(item)"></my-shop-card>-->
<!--                      </div>-->
<!--                      <div v-for="(item, index) in shopList2" :key="item.id">-->
<!--                          <search-plist style="width: 45.7vw;" v-if="index % 2 != 0" :row="item" @plusTwo="addPinSecorend(arguments)" @minusTwo="jjPinSecorend(arguments)" @toInfo="toInfo" @expend="changeExpend"></search-plist>-->
<!--                      </div>-->
<!--                  </div>-->
              </div>
          </van-list>
        </div>
        <van-popup v-model="shopShow" closeable position="bottom" round :style="{ height: '40%' }" >
                  <div style="margin-top: 40px;padding: 0 5.3vw">
                      <div style="display: flex;padding-bottom: 6.8vw;border-bottom: .27vw solid rgba(151, 151, 151, .17)">
                          <img :src="shopInfo.goodsImg" style="width: 19.1vw;height: 19.1vw">
                          <div class="shopListInfo" style="margin-left: 2.4vw">
                              <div style="font-size: 3.73vw; width: 55vw; margin-top: .8vw;font-weight: bold">
                                  {{shopInfo.goodsName}}
                                  <!--          精品红油-->
                              </div>
                              <div style="justify-content: left;margin: 1.87vw 0 1.87vw;color: #9f9f9f;font-size: 2.67vw">
                                  销量: {{shopInfo.monthlySales || 0}}
                              </div>
                              <div  class="shopCardMoney" style="margin-bottom: 0;line-height: 5.33vw;height: 5.33vw">
                                  <div>
                                      <span style="font-size: 3.47vw;letter-spacing: -.3vw;">￥</span><span style="font-size: 5.33vw;font-weight: bold">{{$utils.priceFormat(shopInfo.price)}}</span>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div style="margin-top: 7.5vw;justify-content: space-between" class="centerBox">
                          <div style="font-size: 3.4vw">数量</div>
                          <div style="" class="shopListStepper">
                              <van-stepper
                                      v-model="shopQty"
                                      :step="shopInfo.miniBuyQty"
                                      input-width="19.1vw"
                                      button-size="4.8vw"
                                      integer
                                      :min="shopInfo.miniBuyQty">
                              </van-stepper>
                          </div>
                      </div>
                      <div style="margin-top: 6.3vw" @click="addCart">
                          <div style="width: 100%;border: .2vw solid #da4e4e;color: #da3939; font-size: 3.9vw;height: 9.2vw;border-radius: 999px" class="centerBox">
                              加入购物车
                          </div>
                      </div>
                  </div>
              </van-popup>
      </van-popup>
    </div>
</template>

<script>
// import successIcon from '../../assets/img/successIcon.png'
// import cartIcon from '../../assets/img/cartIcon.png'
export default {
  props: {
    isShowNum: Number,
    row: Object
  },
  data () {
    return {
      isShow: false,
      customStepperConfig: {},
      currentQty: 0,
      shopShow: false,
      shopQty: 0,
      sku: {
        // 所有sku规格类目与其值的从属关系，比如商品有颜色和尺码两大类规格，颜色下面又有红色和蓝色两个规格值。
        // 可以理解为一个商品可以有多个规格类目，一个规格类目下可以有多个规格值。
        tree: [
        ],
        // 所有 sku 的组合列表，比如红色、M 码为一个 sku 组合，红色、S 码为另一个组合
        list: [],
        // price: '1.00', // 默认价格（单位元）
        // stock_num: 227, // 商品总库存
        hide_stock: false, // 是否隐藏剩余库存
        startSaleNum: 0, // 起售数量
        quota: 0, // 当前限购数量
        limitQty: 0 // 总限购数量
      },
      goods: {
        // 默认商品 sku 缩略图
        picture: ''
      },
      initialSku: {},
      shopInfo: {
        minPrice: 0,
        maxPrice: 0,
        goodsImg: [],
        goodsName: '',
        tag: '',
        salesVolume: 0
      },
      form: {
        name: ''
      },
      shopList: [],
      shopList2: [],
      selectItem: {},
      pagingData: {
        loading: false,
        finished: false,
        currentPage: 1,
        pageSize: 10
      },
      showNum: 0
    }
  },
  watch: {
    isShowNum () {
      this.isShow = true
      this.searchSubmit()
    }
  },
  created () {
    // this.form.name = this.$route.query.name || ''
    // if (!this.form.name) {
    //   this.shopList = []
    //   return
    // }
    // this.searchSubmit()
    // let self = this
    // this.customStepperConfig = {
    //   handleStepperChange (currentValue) {
    //     self.currentQty = currentValue
    //   }
    // }
  },
  activated () {
    // if (this.showNum) {
    //   this.form.name = this.$route.query.name || ''
    //   let self = this
    //   this.customStepperConfig = {
    //     handleStepperChange (currentValue) {
    //       self.currentQty = currentValue
    //     }
    //   }
    //   if (!this.form.name) {
    //     this.shopList = []
    //     return
    //   }
    //   this.searchSubmit()
    // }
    // this.showNum++
  },
  methods: {
    // 第一次增加拼箱
    addPinFirst (row, children) {
      const self = this
      self.$toast.loading({
        duration: 0
      })
      console.log(row)
      console.log(children)
      children.shopGoodsVOList.forEach(item => {
        this.$set(item, 'goodsId', item.id)
        this.$set(item, 'imgPath', item.goodsImg)
        this.$set(item, 'containerLoadId', children.id)
        this.$set(item, 'qty', 0)
        item.miniBuyQty = item.hsgMiniBuyQty
      })
      children.shopGoodsVOList.forEach(item => {
        if (item.id === row.id) {
          this.$set(item, 'goodsId', item.id)
          this.$set(item, 'imgPath', item.goodsImg)
          this.$set(item, 'containerLoadId', children.id)
          this.$set(item, 'qty', row.hsgMiniBuyQty)
          item.miniBuyQty = item.hsgMiniBuyQty
        }
      })
      self.$request.shop.addCartGoods2({
        qty: children.specificationQty,
        ...children,
        category: row.category,
        mainGoodsAddFlag: 1,
        miniBuyQty: children.miniBuyQty,
        containerLoad: children.id,
        containerLoadGoodsList: children.shopGoodsVOList
      })
        .then((response) => {
          if (response.code === '200') {
            // children.buyQty++
            self.$toast.clear()
            this.searchSubmit()
          } else {
            // console.log(response)
            self.$toast(response.msg)
          }
        })
    },
    // 加拼箱
    addPinSecorend (data) {
      this.$toast.loading({
        duration: 0
      })
      console.log(data[0]) // 里面
      console.log(data[1]) // 外面
      let a = 0
      data[1].shopGoodsVOList.forEach(item => {
        if (item.buyQty) {
          a++
        }
      })
      if (!a) {
        this.addPinFirst(data[0], data[1])
        return
      }
      const containerLoadGoodsList = []
      if (data[0]) {
        containerLoadGoodsList.push({
          category: data[0].category,
          goodsId: data[0].id,
          containerLoadId: data[1].id,
          qty: data[0].hsgMiniBuyQty,
          containerLoad: data[0].containerLoad,
          opFlag: 1
        })
      }
      this.$request.shop.changeCartGoodsNum2({
        goodsId: data[1].id,
        category: data[0].category,
        opFlag: 0,
        containerLoadName: data[1].containerLoadName,
        miniBuyQty: data[1].miniBuyQty,
        containerLoadGoodsList: containerLoadGoodsList
      })
        .then((response) => {
          if (response.code === '200') {
            this.$toast.clear()
            this.searchSubmit()
            // this.categoryChange2(this.trueItem)
          } else {
            this.$toast(response.msg)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // 减拼箱
    jjPinSecorend (data) {
      this.$toast.loading({
        duration: 0
      })
      const containerLoadGoodsList = []
      if (data[0]) {
        containerLoadGoodsList.push({
          category: data[0].category,
          goodsId: data[0].id,
          containerLoadId: data[1].id,
          qty: data[0].hsgMiniBuyQty,
          opFlag: 2
        })
      }
      this.$request.shop.changeCartGoodsNum2({
        goodsId: data[1].id,
        category: data[0].category,
        opFlag: 0,
        containerLoadName: data[1].containerLoadName,
        miniBuyQty: data[1].miniBuyQty,
        containerLoad: data[0].containerLoad,
        containerLoadGoodsList: containerLoadGoodsList
      })
        .then((response) => {
          if (response.code === '200') {
            this.$toast.clear()
            this.searchSubmit()
            // this.categoryChange2(this.trueItem)
          } else {
            this.$toast(response.msg)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    onClickLeft () {
      this.isShow = false
      this.shopList = []
      this.shopList2 = []
      this.$emit('back')
    },
    toInfo (id) {
      this.$router.push({ name: 'ShopInfo', query: { id } })
    },
    changeExpend (item) {
      item.show = !item.show
    },
    initPage () {
      // this.shopList = []
      this.pagingData = {
        loading: false,
        finished: false,
        currentPage: 1,
        pageSize: 10
      }
    },
    // 开始加购物车了
    addCart () {
      console.log(this.selectItem)
      const self = this
      self.$toast.loading({
        duration: 0
      })
      if (this.selectItem.buyQty) {
        this.changeCartGoodsNum()
        return
      }
      if (this.selectItem.minGoodsList.length > 0) {
        this.selectItem.minGoodsList.forEach(item => {
          this.$set(item, 'goodsId', item.minId)
          this.$set(item, 'imgPath', item.goodsImg)
          this.$set(item, 'qty', 0)
        })
      }
      self.$request.shop.addCartGoods({
        qty: this.shopQty,
        minCartGoodsList: this.selectItem.minGoodsList || [],
        ...this.shopInfo
      })
        .then((response) => {
          self.$toast.clear()
          if (response.code === '200') {
            self.$toast({
              message: '已成功加入购物车'
            })
            self.searchSubmit()
            self.shopShow = false
          } else {
            // console.log(response)
            self.$toast(response.msg)
          }
        })
    },
    // 第二次加购物车
    changeCartGoodsNum () {
      this.$toast.loading({
        duration: 0
      })
      let opFlag = 0
      let chaNumber = 0
      console.log(this.shopQty)
      console.log(this.selectItem.buyQty)
      if (this.shopQty > this.selectItem.buyQty) {
        opFlag = 1
        chaNumber = Number(this.shopQty) - Number(this.selectItem.buyQty)
      } else if (this.shopQty < this.selectItem.buyQty) {
        opFlag = 2
        chaNumber = Number(this.selectItem.buyQty) - Number(this.shopQty)
      } else {
        opFlag = 3
        chaNumber = ''
      }
      this.$request.shop.changeCartGoodsNum({
        goodsId: this.shopInfo.id,
        category: this.shopInfo.category,
        miniBuyQty: chaNumber,
        minCartGoodsList: this.shopInfo.minCartGoodsList,
        opFlag: opFlag
      })
        .then((response) => {
          this.$toast.clear()
          if (response.code === '200') {
            this.searchSubmit()
            this.shopShow = false
          } else {
            this.$toast(response.msg)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // 第一次增加附属品
    addCartTwo (row, children) {
      // console.log(row)
      const self = this
      const minCartGoodsList = []
      if (row) {
        minCartGoodsList.push({
          category: row.category,
          goodsId: row.minId,
          goodsName: row.goodsName,
          qty: row.miniBuyQty,
          imgPath: row.goodsImg,
          price: row.price,
          unitPrice: row.unitPrice
        })
      }
      self.$toast.loading({
        duration: 0
      })
      self.$request.shop.addCartGoods({
        qty: children.specificationQty,
        ...children,
        goodsId: children.id,
        mainGoodsAddFlag: 1,
        miniBuyQty: children.miniBuyQty,
        minCartGoodsList: minCartGoodsList
      })
        .then((response) => {
          self.$toast.clear()
          if (response.code === '200') {
            // children.buyQty++
            // this.selectCategory2()
            // this.searchSubmit()
          } else {
            // console.log(response)
            self.$toast(response.msg)
          }
        })
    },
    // 第二次增加附属品
    changeCartGoodsNumTwo (data) {
      console.log(data[1])
      if (data[1].buyQty > 0) {
        if (!data[0].buyQty) {
          this.addCartTwo(data[0], data[1])
          return
        }
        this.$toast.loading({
          duration: 0
        })
        console.log(data)
        const minCartGoodsList = []
        if (data[0]) {
          minCartGoodsList.push({
            category: data[0].category,
            goodsId: data[0].minId,
            opFlag: 1
          })
        }
        this.$request.shop.changeCartGoodsNum({
          goodsId: data[1].id,
          category: data[1].category,
          opFlag: 0,
          miniBuyQty: data[1].miniBuyQty,
          minCartGoodsList: minCartGoodsList
        })
          .then((response) => {
            this.$toast.clear()
            if (response.code === '200') {
              this.searchSubmit()
            } else {
              this.$toast(response.msg)
            }
          })
          .catch((error) => {
            console.log(error)
          })
      } else {
        this.$toast('请选择主商品')
      }
    },
    // 第二次减少附属品
    minusCartGoodsNumTwo (data) {
      console.log(data[1])
      if (!data[0].buyQty) {
        this.addCart(data[0])
        return
      }
      this.$toast.loading({
        duration: 0
      })
      const minCartGoodsList = []
      if (data[0]) {
        minCartGoodsList.push({
          category: data[0].category,
          goodsId: data[0].minId,
          opFlag: 2
        })
      }
      this.$request.shop.changeCartGoodsNum({
        ...data[1],
        goodsId: data[1].id,
        opFlag: 0,
        miniBuyQty: data[1].miniBuyQty,
        minCartGoodsList: minCartGoodsList
      })
        .then((response) => {
          this.$toast.clear()
          if (response.code === '200') {
            this.searchSubmit()
          } else {
            this.$toast(response.msg)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    searchSubmit () {
      // this.$router.replace({path: '/myMenu/shopInquire', query: {name: this.form.name}})
      this.initPage()
      this.onLoad()
    },
    onLoad () {
      this.selectGoods()
      this.selectGoods2()
      this.pagingData.currentPage++
    },
    // 第一个加号
    changeShop (item) {
      console.log(item)
      this.selectItem = item
      this.$toast.loading({
        duration: 0
      })
      this.$request.shop.shopGetById(item.id)
        .then((response) => {
          this.$toast.clear()
          if (item.buyQty) {
            this.shopQty = item.buyQty
          } else {
            this.shopQty = item.miniBuyQty
          }
          this.shopInfo = response.data
          this.shopShow = true
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // 商品列表
    selectGoods () {
      this.$request.shop.goods({ goodsName: this.row.title }, {
        currentPage: this.pagingData.currentPage,
        pageSize: this.pagingData.pageSize
      })
        .then((response) => {
          if (response.code !== '200') {
            this.pagingData.loading = false
            this.pagingData.finished = true
            return
          }
          this.pagingData.loading = false
          if (response.data.records.length < this.pagingData.pageSize) {
            this.pagingData.finished = true
          }
          response.data.records.forEach(item => {
            this.$set(item, 'show', false)
            // console.log(item)
            // console.log(this.shopList)
            if (this.shopList.length) {
              this.shopList.forEach(cate => {
                if (item.id === cate.id && cate.show) {
                  item.show = true
                }
              })
            }
            this.shopList = []
          })
          // this.shopList = response.data.records
          this.shopList.push(...response.data.records)
          console.log(this.shopList)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // 拼箱列表
    selectGoods2 () {
      console.log(this.shopList2)
      this.$request.shop.goods2({ goodsName: this.row.title }, {
        currentPage: this.pagingData.currentPage,
        pageSize: this.pagingData.pageSize
      })
        .then((response) => {
          if (response.code !== '200') {
            this.pagingData.loading = false
            this.pagingData.finished = true
            return
          }
          this.pagingData.loading = false
          if (response.data.records.length < this.pagingData.pageSize) {
            this.pagingData.finished = true
          }
          response.data.records.forEach(item => {
            this.$set(item, 'show', true)
            // console.log(item)
            // console.log(this.shopList)
            // if (this.shopList2.length) {
            //   this.shopList2.forEach(cate => {
            //     console.log(cate)
            //     if (item.id === cate.id && cate.show) {
            //       item.show = true
            //     }
            //   })
            // }
            this.shopList2 = []
          })
          this.shopList2.push(...response.data.records)
          // this.shopList2 = response.data.records
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>

<style scoped>
</style>
